<template>
    <div id="entire_calendar">
		<div class="calendar-month">

            <div class="calendar-month-header">
                <div class="month_displayed">
                    <CalendarDateIndicator
                        :selected-date="selectedDate"
                        class="calendar-month-header-selected-month"
                    />
                </div>
                <div class="navigate_months">
                    <CalendarDateSelector
                        :current-date="today"
                        :selected-date="selectedDate"
                        @dateSelected="selectDate"
                    />
                </div>
            </div>

            <div class="weekday_container">
                <CalendarWeekdays />
            </div>

            <div class="dates_and_days">
                <ol class="days-grid">
                    <CalendarMonthDayItem
                        v-for="day in days"
                        :key="day.date"
                        :day="day"
                        :is-today="day.date === today"
                    />
                </ol>
            </div>

        </div>
    </div>
</template>

<script>
    import dayjs from "dayjs";
    import weekday from "dayjs/plugin/weekday";
    import weekOfYear from "dayjs/plugin/weekOfYear";
    import CalendarWeekdays from './Dashboard/Calendar/CalendarWeekdays.vue'
    import CalendarMonthDayItem from './Dashboard/Calendar/CalendarMonthDayItem.vue'
    import CalendarDateIndicator from "./Dashboard/Calendar/CalendarDateIndicator";
    import CalendarDateSelector from "./Dashboard/Calendar/CalendarDateSelector";


    dayjs.extend(weekday);
    dayjs.extend(weekOfYear);

    export default {
        name: "Calendar",
        
        components: {
            CalendarMonthDayItem,
            CalendarWeekdays,
            CalendarDateIndicator,
            CalendarDateSelector
        },

        data() {
            return {
                selectedDate: dayjs(),
            };
        },

        methods: {
            selectDate(newSelectedDate) {
                this.selectedDate = newSelectedDate;
            },
            getWeekday(date) {
                return dayjs(date).weekday();
            },
        },


        // computed: {
            //     days() {
            //         return [
            //             { date: "2020-06-29", isCurrentMonth: false },
            //             { date: "2020-06-30", isCurrentMonth: false },
            //             { date: "2020-07-01", isCurrentMonth: true },
            //             { date: "2020-07-02", isCurrentMonth: true },

            //             { date: "2020-07-31", isCurrentMonth: true },
            //             { date: "2020-08-01", isCurrentMonth: false },
            //             { date: "2020-08-02", isCurrentMonth: false },

            //             ...this.previousMonthDays,
            //             ...this.currentMonthDays,
            //             ...this.nextMonthDays

            //         ];
            //     },

            //     numberOfDaysInMonth() {
            //         return dayjs(this.selectedDate).daysInMonth();
            //     },

            //     currentMonthDays() {
            //         return [...Array(this.numberOfDaysInMonth)].map((day, index) => {
            //             return {
            //                 date: dayjs(`${this.year}-${this.month}-${index + 1}`).format("YYYY-MM-DD"),
            //                 isCurrentMonth: true
            //             };
            //         });
            //     },

            //     previousMonthDays() {
            //         const firstDayOfTheMonthWeekday = this.getWeekday(this.currentMonthDays[0].date);
            //         const previousMonth = dayjs(`${this.year}-${this.month}-01`).subtract(1, "month");

            //         // Cover first day of the month being sunday (firstDayOfTheMonthWeekday === 0)
            //         const visibleNumberOfDaysFromPreviousMonth = firstDayOfTheMonthWeekday ? firstDayOfTheMonthWeekday - 1 : 6;

            //         const previousMonthLastMondayDayOfMonth = dayjs(this.currentMonthDays[0].date).subtract(visibleNumberOfDaysFromPreviousMonth, "day").date();

            //         return [...Array(visibleNumberOfDaysFromPreviousMonth)].map((day, index) => {
            //             return {
            //                 date: dayjs(`${previousMonth.year()}-${previousMonth.month() + 1}-${previousMonthLastMondayDayOfMonth + index}`).format("YYYY-MM-DD"),
            //                 isCurrentMonth: false
            //             }
            //         });
            //     },

            //     nextMonthDays() {
            //         const lastDayOfTheMonthWeekday = this.getWeekday(`${this.year}-${this.month}-${this.currentMonthDays.length}`);
            //         const nextMonth = dayjs(`${this.year}-${this.month}-01`).add(1, "month");
            //         const visibleNumberOfDaysFromNextMonth = lastDayOfTheMonthWeekday ? 7 - lastDayOfTheMonthWeekday : lastDayOfTheMonthWeekday;

            //         return [...Array(visibleNumberOfDaysFromNextMonth)].map((day, index) => {
            //             return {
            //                 date: dayjs(`${nextMonth.year()}-${nextMonth.month() + 1}-${index + 1}`).format("YYYY-MM-DD"),
            //                 isCurrentMonth: false
            //             };
            //         });
            //     },

        // }

        computed: {
            days() {
                return [
                    ...this.previousMonthDays,
                    ...this.currentMonthDays,
                    ...this.nextMonthDays
                ];
            },

            today() {
                return dayjs().format("YYYY-MM-DD");
            },

            month() {
                return Number(this.selectedDate.format("M"));
            },

            year() {
                return Number(this.selectedDate.format("YYYY"));
            },

            numberOfDaysInMonth() {
                return dayjs(this.selectedDate).daysInMonth();
            },

            currentMonthDays() {
                return [...Array(this.numberOfDaysInMonth)].map((day, index) => {
                    return {
                        date: dayjs(`${this.year}-${this.month}-${index + 1}`).format(
                            "YYYY-MM-DD"
                        ),
                        isCurrentMonth: true,
                    };
                });
            },

            previousMonthDays() {
                const firstDayOfTheMonthWeekday = this.getWeekday(
                    this.currentMonthDays[0].date
                );
                const previousMonth = dayjs(`${this.year}-${this.month}-01`).subtract(
                    1, "month"
                );

                // Cover first day of the month being sunday (firstDayOfTheMonthWeekday === 0)
                const visibleNumberOfDaysFromPreviousMonth = firstDayOfTheMonthWeekday
                    ? firstDayOfTheMonthWeekday - 1
                    : 6;

                const previousMonthLastMondayDayOfMonth = dayjs(
                    this.currentMonthDays[0].date
                )
                    .subtract(visibleNumberOfDaysFromPreviousMonth, "day")
                    .date();

                return [...Array(visibleNumberOfDaysFromPreviousMonth)].map(
                    (day, index) => {
                        return {
                            date: dayjs(
                                `${previousMonth.year()}-${previousMonth.month() +
                                1}-${previousMonthLastMondayDayOfMonth + index}`
                            ).format("YYYY-MM-DD"),
                            isCurrentMonth: false,
                        };
                    }
                );
            },

            nextMonthDays() {
                const lastDayOfTheMonthWeekday = this.getWeekday(
                    `${this.year}-${this.month}-${this.currentMonthDays.length}`
                );

                const nextMonth = dayjs(`${this.year}-${this.month}-01`).add(1, "month");

                const visibleNumberOfDaysFromNextMonth = lastDayOfTheMonthWeekday
                    ? 7 - lastDayOfTheMonthWeekday
                    : lastDayOfTheMonthWeekday;

                return [...Array(visibleNumberOfDaysFromNextMonth)].map((day, index) => {
                    return {
                        date: dayjs(
                            `${nextMonth.year()}-${nextMonth.month() + 1}-${index + 1}`
                        ).format("YYYY-MM-DD"),
                        isCurrentMonth: false,
                    };
                });
            }
        },

        methods: {
            getWeekday(date) {
                return dayjs(date).weekday();
            },

            selectDate(newSelectedDate) {
                this.selectedDate = newSelectedDate;
            }
        }
    };
</script>

<style lang="scss" scoped>

#entire_calendar {
    width: 100%;
    height: 100%;
    padding-top: 10%;

    .calendar-month {
        width: 100%;
        height: 100%;
        position: relative;
        // background-color: red;

        .calendar-month-header {
            display: flex;
            width: 100%;
            height: 2em;

            .month_displayed {
                width: 50%;
                height: 100%;
            }
        }

        .weekday_container {
            // background-color: red;
            width: 100%;
            height: 2em;
            display: flex;
        }

        .dates_and_days {
            // background-color: green;
            width: 100%;
            height: 10em;
            display: flex;
            padding-top: 0.2em;

            ol {
                width: 100%;
                height: 100%;
                display: grid;
                grid-template-columns: repeat(7, 1fr);
                padding: 0 5.5%;
                position: relative;
                grid-column-gap: 1em;
                grid-row-gap: 1em;
            }
        }

    }
}

</style>

